const RemainingPaymentModal = ({
  onPayRemaining,
  remainingAmount,
  loading,
  onClose
}) => {
  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        <button
          className="payment-modal-close"
          onClick={onClose}
        >
          ×
        </button>

        <h3>Remaining Payment</h3>

        <p>
          Your wallet balance has been used.
          Please pay the remaining amount using Stripe.
        </p>

        {remainingAmount > 0 && (
          <p>
            Remaining Amount: <strong>${remainingAmount}</strong>
          </p>
        )}

        <button
          type="button"
          onClick={onPayRemaining}
          disabled={loading}
        >
          {loading ? "Processing..." : "Pay Remaining with Stripe"}
        </button>

      </div>
    </div>
  );
};

export default RemainingPaymentModal;